import { MprcConfirmDialog, MprcInformationDialog, MprcRequestIndicator } from "components";
import { MprcRequestSnackbarErrorReport } from "components/MprcRequestErrorReport";
import { EnrollStatus } from "generated/CoreApi_v1";
import { enqueueSnackbar } from "notistack";
import { useCoreApi } from "providers/CoreApiProvider";
import { useEffect, useState } from "react";
import { Trans, useTranslation } from "react-i18next";
import { useEnrollmentViewContext } from "..";

/////////////////////////////////////////////////////////////////////////////////////

interface IProps {
    open: boolean;
    onAction: (status: "canceled" | "closing" | "closed") => void;
}

/////////////////////////////////////////////////////////////////////////////////////

export const DoCloseEnrollment: React.FC<IProps> = (props) => {

    const { open, onAction } = props;

    const api = useCoreApi();
    const { t } = useTranslation("lms");
    const { enrollment, onReload } = useEnrollmentViewContext();

    const [dialog, setDialog] = useState<any>();
    const [loading, setLoading] = useState<boolean>(false);
    const [saving, setSaving] = useState<boolean>(false);
    const [finalStatus, setFinalStatus] = useState<EnrollStatus | null>(null);

    ///
    async function save() {
        setSaving(true);
        onAction("closing");
        try {
            var result = await api.v1.enrollment.closeEnrollmentManual({
                enrollmentId: enrollment.enrollmentId,
                forced: enrollment.canForceFinish
            });
            if (result.data.success === true) {
                enqueueSnackbar(t("Student.EnrollmentView.CloseEnrollmentSuccessMessage"), { variant: "success" });
                onAction("closed");
            }
            else {
                enqueueSnackbar(t("Student.EnrollmentView.CloseEnrollmentErrorMessage"), { variant: "error" });
            }
        }
        catch (e) {
            MprcRequestSnackbarErrorReport(e);
        }
        finally {
            setSaving(false);
            setFinalStatus(null);
        }
    }


    useEffect(() => {
        if (open) {
            setLoading(true);
            api.v1.enrollment.getEnrollmentFinalResult({
                enrollmentId: enrollment.enrollmentId,
                currentScore: enrollment.scorePercent,
                currentCredits: enrollment.learnPath?.credits ?? null,
                currentProgress: enrollment.progressPercent
            })
                .then(response => {
                    if (response.data != null) {
                        if (response.data.progressOrScoreChanged === true) {

                            setDialog(
                                <MprcInformationDialog
                                    message={t("Student.EnrollmentView.ScoreOrProgressChangedMessage")}
                                    onClose={() => { onReload(); setDialog(null); }}
                                />
                            );
                        } else {
                            setFinalStatus(response.data.finalStatus);
                        }
                    }
                })
                .catch(e => MprcRequestSnackbarErrorReport(e))
                .finally(() => setLoading(false));
        }
    }, [open]);


    /////////////////////////////////////////////////////////////////////////////////////
    /// RENDER
    /////////////////////////////////////////////////////////////////////////////////////

    return (
        <>
            <MprcRequestIndicator visible={loading || saving} type={saving ? "post" : "request"} message={saving ? t("Student.EnrollmentView.ClosingText") : undefined} />
            {dialog}
            {finalStatus != null &&
                <MprcConfirmDialog
                    open={open}
                    message={<span>
                        <Trans
                            i18nKey="Student.EnrollmentView.ConfirmCloseEnrollmentMessage"
                            values={{
                                status:
                                    finalStatus == EnrollStatus.Approved
                                        ? enrollment.hasScore ? t("Student.EnrollmentView.ApprovedText") : t("Student.EnrollmentView.CompletedText")
                                        : enrollment.hasScore ? t("Student.EnrollmentView.ReprovedText") : t("Student.EnrollmentView.NotCompletedText")
                            }}
                            t={t}
                        />
                    </span>}
                    severity={finalStatus == EnrollStatus.Reproved ? "danger" : "question"}
                    onClose={
                        (yes) => {
                            if (yes) save();
                            else {
                                onAction("canceled");
                                setFinalStatus(null);
                            }


                        }
                    }
                />
            }
        </>
    );
};

